import { render } from "./New.vue?vue&type=template&id=6d468190&scoped=true&ts=true"
import script from "./New.vue?vue&type=script&lang=ts"
export * from "./New.vue?vue&type=script&lang=ts"

import "./New.vue?vue&type=style&index=0&id=6d468190&scoped=true&lang=css"

import exportComponent from "/var/www/prod/fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d468190"]])

export default __exports__